.timeline {
    &__title {
        font: use-font-accent("700 20px/27px");
        margin-bottom: 20px;
        text-transform: uppercase;
    }

    &__list {
        display: flex;
        flex-flow: column nowrap;
        font: use-font("400 18px/29px");
        gap: 20px;
        list-style: disc;
        margin: 0;
        padding-left: 20px;
    }
}